import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import { SystemPartner } from '../api/types';
import config from '../config';

async function getSystemPartner(axios: AxiosInstance): Promise<SystemPartner[]> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/systempartner`);
  return data;
}

export default function useSystemPartnerQuery() {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(),
    queryFn: () => getSystemPartner(axios),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey() {
  return ['System Partner'] as const satisfies QueryKey;
}
useSystemPartnerQuery.getKey = getKey;
